/* src/app/components/dashboard/dashboard.component.scss */
h1.extra-large {
  font-size: 32px;
}
.alert-danger {
  margin-top: 20px;
  text-align: center;
  font-size: 46px;
  color: #fff;
  background-color: #ed1c24;
  padding-bottom: 25px;
}
.alert-danger h5 {
  font-size: 18px;
  color: #fff;
}
.panel h1.extra-large {
  font-size: 64px;
  margin: 0px;
}
.table-header-no-bottom-border {
  border-bottom: solid 1px transparent;
  padding: 15px 0;
}
.margin-bottom-50 {
  margin-bottom: 50px;
}
.table {
  border-color: transparent !important;
}
.table {
  --bs-table-striped-bg: #fff !important;
}
.td-heading {
  border-color: lightgrey;
}
#th-appvarname {
  color: #F76808 !important;
  font-size: 0.97rem;
  font-family: open_sansregular, sans-serif;
}
table a {
  pointer-events: auto !important;
  cursor: pointer !important;
  display: inline-block;
  position: relative;
  z-index: 1;
}
main[data-animation-state] a,
main a {
  pointer-events: auto !important;
  cursor: pointer !important;
}
.table-responsive {
  pointer-events: auto !important;
}
tbody tr td a {
  pointer-events: auto !important;
  cursor: pointer !important;
}
.channel-section {
  margin-bottom: 2rem;
}
.channel-section .table-ss {
  margin-bottom: 1rem;
}
.download-link {
  text-decoration: none;
  color: #0071bb;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background-color 0.2s ease;
}
.download-link:hover,
.download-link:focus {
  background-color: rgba(0, 113, 187, 0.1);
  text-decoration: underline;
  outline: 2px solid #0071bb;
  outline-offset: 2px;
}
.download-link:active {
  background-color: rgba(0, 113, 187, 0.2);
}
.download-link i {
  margin-right: 0.5rem;
}
.table {
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
}
.table thead th {
  background-color: white;
  border-bottom: 2px solid #dee2e6;
}
.table tbody td {
  border-bottom: 1px solid #dee2e6;
  padding: 0.75rem;
  vertical-align: middle;
}
.table > :not(caption) > * > * {
  padding: 0.25rem 0.25rem;
}
/*# sourceMappingURL=dashboard.component.css.map */
